import React, { useContext } from "react"
import { IUserAccountInfo, IUserCompany } from "platform-client/types/user"

type UserContextType = {
  user?: IUserAccountInfo
  canBindBusiness?: boolean
  /** the branch (office) the session is working in */
  activeBranch?: IUserCompany
  /** all the branches (offices) the user belongs to, sorted by name */
  branches?: IUserCompany[]
}

const UserContext = React.createContext<UserContextType>({
  user: undefined
})

export const useUserContext = (): UserContextType => {
  const userContext = useContext(UserContext)

  if (userContext.user === undefined) {
    throw new Error(
      "You must wrap your component in `UserContext.Provider` before trying to access this."
    )
  }

  return userContext
}

export default UserContext
